import React, { useState, useEffect } from 'react'
import { ContentCard, OverContainerSection } from './styles'
import { IVacancy } from 'src/types/contenfull'
import { clientVacant } from 'src/api/contenfull'
import { MapWereHiring } from './mapWereHiring'

export const CardWereHiring = () => {
    const [vacant, setVacant] = useState<IVacancy[]>([])

    useEffect(() => {
        const fetchEntries = async () => {
            try {
                const response = await clientVacant.getEntries({
                    content_type: 'vacancies',
                })

                setVacant(response.items as never)
            } catch (error) {
                console.error('Error fetching entries:', error)
            }
        }

        fetchEntries()
    }, [])
    return (
        <OverContainerSection id={'vacant'}>
            <ContentCard
                paddingTop={['large', 'large', 'xsixty', 'xsixty']}
                marginBottom={['medium', 'medium', 'large', 'titlle']}
            >
                {vacant.map((vacantData: IVacancy) => {
                    return (
                        <MapWereHiring
                            key={vacantData.sys?.id}
                            {...vacantData}
                        />
                    )
                })}
            </ContentCard>
        </OverContainerSection>
    )
}
